import {
    FETCH_SCHEMES_REQUEST,
    FETCH_SCHEMES_SUCCESS,
    FETCH_SCHEMES_FAILURE,
  } from "./FetchMedSchemesTypes";
  import api from "../../utils/Api";
  
  export const fetchSchemesRequest = () => {
    return {
      type: FETCH_SCHEMES_REQUEST,
    };
  };
  
  export const fetchSchemesSuccess = (schemes) => {
    return {
      type: FETCH_SCHEMES_SUCCESS,
      payload: schemes,
    };
  };
  
  export const fetchSchemesFailure = (error) => {
    return {
      type: FETCH_SCHEMES_FAILURE,
      payload: error,
    };
  };
  
  export const fetchMedSchemes = (scheme_name) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchSchemesRequest);
      try {
        const response = await api.get(
          "relatedparty/schemes/autocomplete?search_key=" + scheme_name,
          {
            headers: headers,
          }
        );
  
        const schemes = response.data.data;
        //console.log("******* patient autocomplete - ", patient);
        dispatch(fetchSchemesSuccess(schemes));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchSchemesFailure(errorMsg));
      }
    };
  };
  